import { css } from 'styled-components';
import { select } from '@lendi-ui/theme';
import { map } from '@lendi-ui/breakpoint';

var removeHash = hex => {
  return hex[0] === '#' ? hex.slice(1) : hex;
};

var parseHex = nakedHex => {
  var isShort = nakedHex.length === 3;
  var twoDigitHexR = isShort ? nakedHex.slice(0, 1).concat(nakedHex.slice(0, 1)) : nakedHex.slice(0, 2);
  var twoDigitHexG = isShort ? nakedHex.slice(1, 2).concat(nakedHex.slice(1, 2)) : nakedHex.slice(2, 4);
  var twoDigitHexB = isShort ? nakedHex.slice(2, 3).concat(nakedHex.slice(2, 3)) : nakedHex.slice(4, 6);
  return {
    r: twoDigitHexR,
    g: twoDigitHexG,
    b: twoDigitHexB
  };
};

var hexToDecimal = hex => {
  return parseInt(hex, 16);
};

var hexesToDecimals = _ref => {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b;
  return {
    r: hexToDecimal(r),
    g: hexToDecimal(g),
    b: hexToDecimal(b)
  };
};

var formatRgb = function formatRgb(decimalObject) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var r = decimalObject.r,
      g = decimalObject.g,
      b = decimalObject.b;
  return 'rgba('.concat(r.toString(), ',').concat(g.toString(), ',').concat(b.toString(), ',').concat(alpha.toString(), ')');
};

var hexToRgba = function hexToRgba(hex) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var hashlessHex = removeHash(hex);
  var hexObject = parseHex(hashlessHex);
  var decimalObject = hexesToDecimals(hexObject);
  return formatRgb(decimalObject, a);
};

function color(name, transparency) {
  return _ref => {
    var {
      theme
    } = _ref;

    if (!theme) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }

    var color = select("colors.".concat(name))({
      theme
    });
    return hexToRgba(color, transparency);
  };
}
function fg(name, transparency) {
  return map(name, n => n === undefined ? '' : css(["color:", ";"], color(n, transparency)));
}
function bg(name, transparency) {
  return map(name, n => n === undefined ? '' : css(["background-color:", ";"], color(n, transparency)));
}

export { bg, color, fg };
